import api from './api';

/**
 * Create a buy order
 * @param {Object} orderData
 * @param {string} orderData.type - 'buy'
 * @param {string} orderData.assetType - 'tree' | 'carbon_credit'
 * @param {number} orderData.quantity
 * @param {number} orderData.price
 * @param {string} [orderData.forest] - Required for 'tree'
 */
export const createBuyOrder = async (orderData) => {
  try {
    const response = await api.post('/api/market/buy', orderData);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to create buy order');
  }
};

/**
 * Create a sell order
 * @param {Object} orderData
 * @param {string} orderData.type - 'sell'
 * @param {string} orderData.assetType - 'tree' | 'carbon_credit'
 * @param {number} orderData.quantity
 * @param {number} orderData.price
 * @param {string} [orderData.holdingId] - Required
 */
export const createSellOrder = async (orderData) => {
  try {
    const response = await api.post('/api/market/sell', orderData);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to create sell order');
  }
};

export const cancelOrder = async (orderId) => {
  try {
    const response = await api.delete(`/api/market/orders/${orderId}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to cancel order');
  }
};
